<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 1.33334C4.31992 1.33334 1.33325 4.32001 1.33325 8.00001C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00001C14.6666 4.32001 11.6799 1.33334 7.99992 1.33334ZM2.66659 8.00001C2.66659 5.05334 5.05325 2.66668 7.99992 2.66668C9.23325 2.66668 10.3666 3.08668 11.2666 3.79334L3.79325 11.2667C3.08659 10.3667 2.66659 9.23334 2.66659 8.00001ZM7.99992 13.3333C6.76659 13.3333 5.63325 12.9133 4.73325 12.2067L12.2066 4.73334C12.9133 5.63334 13.3333 6.76668 13.3333 8.00001C13.3333 10.9467 10.9466 13.3333 7.99992 13.3333Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
